module.exports = __webpack_public_path__ + "media/images/black_history_month/okra-vector-950c9fd17b0540e75336d528f20cb7d6.png";